let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("42InX")).then(() => parcelRequire('6ha4w'));